import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LocalAccountService } from '../services/localAccount.service';
import { UserService } from 'app/main/pages/administration-area/services/user.service';
import { AuthService } from '../services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class PoliciesGuard implements CanActivate {


    constructor(
        //
        private localAccountService: LocalAccountService,
        private userService: UserService,
        private router: Router,
        private authService: AuthService) { }

    async canActivate(): Promise<boolean> {
        const loggedIn = this.authService.loggedIn();
        if (loggedIn) {
            const isStudent = this.localAccountService.isStudent();
            const isProfessor = this.localAccountService.isProfessor();

            const oldUser = await this.localAccountService.getAccount();
            let user: any = null;
            try {
                const res: any = await this.userService.getUserInfoPromise();
                user = res.payload;
                if (oldUser) {
                    const newUser: any = oldUser;
                    // newUser.credit = user.credit;
                    // newUser.creditExpireDate = user.creditExpireDate;
                    this.localAccountService.setAccount(newUser);
                }
                const accepted = await this.localAccountService.isPolicyAccepted();
                if ((!isStudent && !isProfessor) || accepted) {
                    if (accepted && window.location.href.includes('acceptances')) {
                        this.router.navigateByUrl('/public-area/redirect');
                    }
                    return true;
                } else {
                    this.router.navigateByUrl('/public-area/acceptances');
                    return false;
                }
            } catch (err) {
                console.error(err);
                return false;
            }
        } else {
            return true;
        }
    }

}
